import { Component, OnInit, Input } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ReportesColocadosService } from '../../../../services/reportes/reportes-colocados.service';
import { CreditosKeys } from '../../../../services/tools/helpers.service';
import { TiposCreditos } from '../../../../services/tools/helpers.service';

@Component({
    selector: 'colocados-footer',
    templateUrl: './colocados-footer.component.html'
  })

export class ColocadosFooterComponent implements OnInit {
    @Input() public activeReport : string = null;
    @Input() public activeFilters : string = null;

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesColocadosService
    ){
    }

    public ngOnInit() {
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        switch(this.activeReport){
            case 'general':
                this.descargarGeneral(this.activeFilters);
                break;
            case CreditosKeys.Personal:
                this.descargarReporteCredito(TiposCreditos.Personal, this.activeFilters);
                break;
            case CreditosKeys.Hipotecario:
                this.descargarReporteCredito(TiposCreditos.Hipotecario, this.activeFilters);
                break;
            case CreditosKeys.Automotriz:
                this.descargarReporteCredito(TiposCreditos.Automotriz, this.activeFilters);
                break;
            case CreditosKeys.Prendario:
                this.descargarReporteCredito(TiposCreditos.Prendario, this.activeFilters);
                break;
            case CreditosKeys.Verde:
                this.descargarReporteCredito(TiposCreditos.Verde, this.activeFilters);
                break;
            case CreditosKeys.Nomina:
                this.descargarReporteCredito(TiposCreditos.Nomina, this.activeFilters);
                break;
            case CreditosKeys.Carburacion:
                this.descargarReporteCredito(TiposCreditos.Carburacion, this.activeFilters);
                break;
            case CreditosKeys.Estacionario:
                this.descargarReporteCredito(TiposCreditos.Estacionario, this.activeFilters);
                break;
        }
    }

    private descargarGeneral(filtros){
        this.reportesService.generalExport(filtros).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private descargarReporteCredito(credito: TiposCreditos, filtros: any){
        this.reportesService.reporteTipoCredito(credito, filtros, true).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/creditos-colocados/components/footer/colocados-footer.component.ts